<template>    
    <v-card class="ma-1 mb-3" max-width="350">
        <v-img
        :src="loadImg"
        @error="loadDefaultImg"
        @click="open(preview)"
        class="pointer"
        height="200px">
        </v-img>
        <v-card-title>
            {{ preview.translations[0].title }}        
        </v-card-title>
        <v-card-subtitle></v-card-subtitle>
        <v-card-actions>
        <v-btn text @click="open(preview)" >Abrir</v-btn>      
        <v-spacer></v-spacer>
            <v-btn icon @click="show = !show" >
                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
        </v-card-actions>
        <v-expand-transition>
        <div v-show="show">
            <v-divider></v-divider>
            <v-card-text>
                {{ preview.translations[0].introduction }}
            </v-card-text>
        </div>
        </v-expand-transition>
    </v-card>   
</template>


<script>
    import router from '../router/index';
    import Api from '../services/Api';
    export default {
        data: () => ({
            show: false,
            showDefaultImg: false,
            hovered: false        
        }),
        props: {
            preview: {
                type: Object,
                required: true
            }
        },
        methods:{
            loadDefaultImg(){
                this.showDefaultImg = true;
            },
            open(preview){
                router.push({ name: 'Card', params: { id: preview.id } });
            }
        },
        computed:{
            loadImg: function(){
                return (this.preview.medias[0] == undefined ? "https://cdn.vuetifyjs.com/images/cards/store.jpg" : Api.getBaseUrl()+"imagens/"+this.preview.medias[0].name);
            }
        }
    }
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
</style>